/**
 * Formats a string into camelCase
 * @param value The string to format
 * @returns The formatted string in camelCase
 */
function formatToCamelCase(value: string): string {
  return value
    .trim() // remove start/end spaces
    .toLowerCase()
    .split(/\s+/) // split by one or more spaces
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('');
}

export default formatToCamelCase;
